import { render, staticRenderFns } from "./TableRef.vue?vue&type=template&id=20e2e0e8&"
import script from "./TableRef.vue?vue&type=script&lang=js&"
export * from "./TableRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports